"use client";
import { jsxs as j, jsx as i } from "react/jsx-runtime";
import { cva as k } from "class-variance-authority";
import { forwardRef as z, useRef as C, useImperativeHandle as R, useState as w, useCallback as l } from "react";
import { Text as S } from "../Text/Text.mjs";
import { cn as p } from "../../../utils/utils.mjs";
const Z = k(
  `
    flex
    flex-col
    size-full
    rounded-sm
    border
    border-dashed
    p-3
    min-h-[7.5rem]
    min-w-[15rem]
    justify-center
    transition-colors
    
    dark:bg-neutral-dark-200
    dark:text-neutral-dark-600
    `,
  {
    variants: {
      state: {
        default: "dark:border-neutral-dark-300",
        loading: "dark:border-neutral-dark-500",
        error: "border-red-400 dark:border-red-400",
        success: "dark:border-neutral-dark-300 min-h-0"
      },
      isDragActive: {
        true: "border-gray-300 dark:border-neutral-dark-600",
        false: ""
      }
    },
    defaultVariants: {
      isDragActive: !1
    }
  }
), H = k(
  `
    text-left
    `,
  {
    variants: {
      state: {
        default: "",
        loading: "",
        success: "",
        error: "text-red-100"
      }
    },
    defaultVariants: {
      state: "default"
    }
  }
), W = z(
  ({
    className: v,
    wrapperClassName: b,
    state: c = "default",
    children: h,
    useButtonWrapper: x = !0,
    helperText: f,
    onPickFile: g,
    onFileDrop: e,
    onDragEnter: a,
    onDragOver: r,
    onDragLeave: s,
    onDrop: d,
    ...N
  }, y) => {
    const u = C(null);
    R(y, () => u.current);
    const [o, n] = w(!1), A = l(
      (t) => {
        t.preventDefault(), t.stopPropagation(), n(!0), a == null || a(t);
      },
      [a]
    ), T = l(
      (t) => {
        t.preventDefault(), t.stopPropagation(), r == null || r(t);
      },
      [r]
    ), I = l(
      (t) => {
        t.preventDefault(), t.stopPropagation(), !t.currentTarget.contains(t.relatedTarget) && (n(!1), s == null || s(t));
      },
      [s]
    ), P = l(
      (t) => {
        t.preventDefault(), t.stopPropagation(), n(!1), t.dataTransfer.files.length > 0 && (e == null || e(t.dataTransfer.files)), d == null || d(t);
      },
      [e, d]
    ), V = p(Z({ isDragActive: o, state: c }), v), m = /* @__PURE__ */ i(
      "div",
      {
        "data-testid": "interactive-zone",
        "data-drag-active": o || void 0,
        onDragEnter: A,
        onDragOver: T,
        onDragLeave: I,
        onDrop: P,
        className: V,
        children: h
      }
    );
    return /* @__PURE__ */ j("div", { className: p("flex flex-col gap-2", b), children: [
      x ? /* @__PURE__ */ i("button", { type: "button", onClick: g, children: m }) : m,
      /* @__PURE__ */ i("input", { ref: u, type: "file", className: "hidden", ...N }),
      f && /* @__PURE__ */ i(S, { fontWeight: "regular", fontSize: "xs", className: H({ state: c }), children: f })
    ] });
  }
);
W.displayName = "FileInput";
export {
  W as FileInput
};
